import { Component, OnInit } from "@angular/core";
import { LayoutService } from "../../../../@lhacksrt/services/layout/layout.service";
import { ActivatedRoute, Router, UrlSegment } from "@angular/router";
import { NavigationItem } from "../../../../@lhacksrt/components";


@Component({
    selector: 'aside-content-header',
    templateUrl: './aside-content-header.component.html',
    standalone: false
})
export class AsideContentHeaderComponent implements OnInit {

    get isClassyLayout(): boolean {
        return this._layoutService.isClassyLayout;
    }

    item: NavigationItem = {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'mat_outline:dashboard',
        link: '/app/dashboard',
        classes: {
            title: 'uppercase'
        },
    };

    constructor(
        private _layoutService: LayoutService,
        private _router: Router
    ) { }

    ngOnInit() {
    }

    navigateToDashboard() {
        if (this._router.url.includes('dashboard')) {
            return;
        }
        this._router.navigate(['/dashboard']);
    }

    isActive(): boolean {
        return this._router.url.includes("dashboard");
    }
}